import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, ArrowRight } from 'lucide-react';
export function AssessmentCTA() {
  return <section className="py-24 relative overflow-hidden" data-id="element-37">
      <div className="container mx-auto px-6" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative bg-gradient-to-br from-primary to-primary-dark rounded-[60px] p-12 lg:p-24 overflow-hidden shadow-2xl shadow-primary/20" data-id="element-39">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-full h-full opacity-10 pointer-events-none" data-id="element-40">
            <svg width="100%" height="100%" viewBox="0 0 800 400" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-41">
              <path d="M-100 200C100 100 300 300 500 200C700 100 900 300 1100 200" stroke="white" strokeWidth="40" data-id="element-42" />
              <path d="M-100 250C100 150 300 350 500 250C700 150 900 350 1100 250" stroke="white" strokeWidth="40" data-id="element-43" />
            </svg>
          </div>
          <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-white/10 rounded-full blur-3xl" data-id="element-44" />

          <div className="grid lg:grid-cols-2 gap-16 items-center relative z-10" data-id="element-45">
            <div data-id="element-46">
              <h2 className="text-4xl lg:text-6xl font-heading font-bold text-white mb-8 leading-tight" data-id="element-47">
                Schedule Your Free Care Assessment
              </h2>
              <p className="text-xl text-white/80 mb-12 leading-relaxed max-w-xl" data-id="element-48">
                Take the first step towards exceptional home healthcare. Our
                experts are ready to design a personalized care plan for your
                loved one.
              </p>
              <div className="flex flex-wrap gap-6" data-id="element-49">
                <button className="px-10 py-5 bg-white text-primary font-bold rounded-full hover:bg-accent transition-all duration-300 shadow-xl hover:-translate-y-1 flex items-center gap-3 text-lg" data-id="element-50">
                  Book Now
                  <ArrowRight className="w-6 h-6" data-id="element-51" />
                </button>
                <a href="tel:240-468-4545" className="px-10 py-5 bg-white/10 text-white font-bold rounded-full border border-white/20 hover:bg-white/20 transition-all duration-300 flex items-center gap-3 text-lg" data-id="element-52">
                  Call 240-468-4545
                </a>
              </div>
            </div>

            <motion.div animate={{
            y: [0, -20, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="hidden lg:flex justify-center" data-id="element-53">
              <div className="relative" data-id="element-54">
                <div className="w-80 h-80 bg-white/20 backdrop-blur-xl rounded-[40px] border border-white/30 flex items-center justify-center shadow-2xl" data-id="element-55">
                  <Calendar className="w-40 h-40 text-white opacity-90" data-id="element-56" />
                </div>
                {/* Floating Elements */}
                <div className="absolute -top-6 -right-6 w-20 h-20 bg-secondary rounded-3xl shadow-lg flex items-center justify-center animate-bounce" data-id="element-57">
                  <span className="text-white font-bold text-2xl" data-id="element-58">!</span>
                </div>
                <div className="absolute -bottom-10 -left-10 p-6 bg-white rounded-3xl shadow-xl" data-id="element-59">
                  <div className="flex items-center gap-3" data-id="element-60">
                    <div className="w-3 h-3 bg-success rounded-full animate-pulse" data-id="element-61" />
                    <span className="text-dark-text font-bold text-sm" data-id="element-62">
                      Available Today
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}